// src/components/Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getRoleType, getRoleBasedRedirect } from './RoleBasedRedirect/getRoleBasedRedirect';
import './Sidebar.css';

const Sidebar = ({ isOpen }) => {
  const { user } = useAuth();

  const roleType = getRoleType(user)
  const { homePath } = getRoleBasedRedirect(user);

  const menuItems = [
    { name: 'Home', path: homePath },
    { name: 'Tenancy', path: '/tenancy' },
    { name: 'AI', path: '/ai' },
    { name: 'Messages', path: '/messages'},
    { name: 'Tenant Info', path: '/tenant-info' },
    { name: 'Landlord Info', path: '/landlord-info' },
    { name: 'Settings', path: '/settings' }
  ];

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <h2 className="sidebar-title">{roleType} Portal</h2>
      <ul className="menu-list">
        {menuItems.map(item => (
          <li key={item.name}>
            <NavLink
              to={item.path}
              className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
              onClick={() => window.innerWidth <= 768 && document.body.click()} // auto-close sidebar on mobile
            >
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
